import { render, staticRenderFns } from "./DealTab.vue?vue&type=template&id=d21a0cfa&scoped=true&"
import script from "./DealTab.vue?vue&type=script&lang=js&"
export * from "./DealTab.vue?vue&type=script&lang=js&"
import style0 from "./DealTab.vue?vue&type=style&index=0&id=d21a0cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a0cfa",
  null
  
)

export default component.exports